import { render, staticRenderFns } from "./Taxe.vue?vue&type=template&id=14feddb7"
import script from "./Taxe.vue?vue&type=script&lang=js"
export * from "./Taxe.vue?vue&type=script&lang=js"
import style0 from "./Taxe.vue?vue&type=style&index=0&id=14feddb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports